import { ListingActivityType } from '@customer-activity/enums/listing-activity-type.enum';

export class AddListingActivityRequest {
    constructor(
        public readonly activity: ListingActivityType,
        public readonly listingCategory: { listingId: string, category: string }[],
        public readonly savedSearchId?: number,
    ) { }
}
